var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOndemand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9535,
    cy: 22.9535,
    r: 22.9535,
    fill: "#EFF5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.52 15.2443V14.9952L31.2708 14.9943L11.3867 14.9275L11.1359 14.9267V15.1775V30.4582V30.7082H11.3859H31.2923H31.5423V30.4582V26.7159C31.5423 26.4003 31.2755 26.1318 30.959 26.1318H30.709V26.1909C30.5138 26.2868 30.3758 26.4894 30.3758 26.7164V29.5404H12.3024V16.0967L30.3534 16.1617V17.4496V19.2985C30.3534 19.6141 30.6203 19.8826 30.9367 19.8826C31.2531 19.8826 31.52 19.6141 31.52 19.2985V17.4273V15.5785V15.2443Z",
    fill: "#2176FF",
    stroke: "#2176FF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6739 22.9507H26.2267V23.6189H14.6739V22.9507Z",
    fill: "#FFCA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6739 21.1243H26.2267V21.7926H14.6739V21.1243Z",
    fill: "#2176FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6739 24.7999H26.2267V25.4682H14.6739V24.7999Z",
    fill: "#2176FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6739 19.2975H21.339V19.9657H14.6739V19.2975Z",
    fill: "#FFCA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9383 27.9404H29.3373V28.6086H24.9383V27.9404Z",
    fill: "#FFCA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3153 23.4629L28.4041 26.4478L31.359 25.9132L37.7352 17.8716L34.647 15.399L28.3153 23.4629ZM36.8019 17.9834L31.0032 25.3121L29.0481 25.6685L29.0036 23.686L34.7577 16.3572L36.8019 17.9834Z",
    fill: "#FFCA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6761 23.7383L34.6007 16.2258L37.0402 18.0376L31.2899 25.6471L29.0246 26.0095L28.6761 23.7383Z",
    fill: "#FFCA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.5036,
    height: 20.5839,
    fill: "white",
    transform: "translate(8.23355 12.3504)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndemand);
export default __webpack_public_path__ + "static/media/ondemand.6c22774b60713bca8190a36a23a5d85f.svg";
export { ForwardRef as ReactComponent };